
import Form from "./Form.vue";
import ProdutoData from "./ProdutosData";
import { mapGetters } from "vuex";
import { onboardStore } from "../../../onboardStore";
import {
  SistemaMixin,
} from "@/modules/Application";

export default {
  name: "app-produtos-create",
  data() {
    return {
      onboardStore,
      produto: new ProdutoData({}),
    };
  },
  components: {
    Form,
  },
  mixins: [SistemaMixin],
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
